import React from 'react';
import { observer } from 'mobx-react';

import { clientStore } from 'apps/client/app';
import Avatar from 'components/Avatar';
import Skeleton from 'components/Skeleton';
import {
  isInDesktopMode,
  switchToHomeTab,
} from 'libs/gutClient/electronBridge';
import { useDesktopCompatibility } from 'hooks/useDesktopCompatible';
import { routerStore } from 'core/routing';
import { DefaultMenuRoute } from 'constants/global';

export const AvatarSkeleton = observer(() => (
  <Skeleton variant='circle' width={24} height={24} />
));

export const ProfileAvatar = observer(() => {
  const { signedInProfile } = clientStore;

  const compatibleWithTab = useDesktopCompatibility({
    feature: 'tab',
  });

  if (!signedInProfile) return <AvatarSkeleton />;

  const { navigate } = routerStore;
  const { fullName, username: profileSlug } = signedInProfile;

  return (
    <Avatar
      onClick={() => {
        if (isInDesktopMode() && compatibleWithTab) {
          switchToHomeTab();

          return;
        }

        navigate(DefaultMenuRoute, {
          spacePath: profileSlug,
        });
      }}
      data-testid='profileAvatar'
      size='medium'
      src={signedInProfile?.avatar?.url}
      name={fullName}
    />
  );
});
